import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { ChancenEventlog } from './ChancenEventlog.js';

/**
 * @entity NotificationSeenEventlog
 */
@Entity()
export class NotificationSeenEventlog extends ChancenEventlog {
  static override _class = 'NotificationSeenEventlog';

  constructor(doc: PartialEntityData<NotificationSeenEventlog>) {
    super(doc);
  }

  @Field(() => ID)
  public notificationID: Maybe<string>;
}
